import { render, staticRenderFns } from "./CardDrink.vue?vue&type=template&id=13084c81&"
import script from "./CardDrink.vue?vue&type=script&lang=js&"
export * from "./CardDrink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports